import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default, { useContext } from 'react';
import styled, { withTheme, ThemeContext } from 'styled-components';
import '../../App.css.js';
import StartYoungHeader from './start-young-header.component.js';
var _excluded = ["style", "titleText", "link", "buttonText", "buttonIcon", "onButtonClick", "icon", "background", "LinkComponent", "textStyle", "isMobile"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Div = styled.div.withConfig({
  displayName: "start-youngcomponent__Div",
  componentId: "sc-7t390v-0"
})(["padding-top:72px;padding-left:88px;padding-right:88px;padding-bottom:72px;background-color:", ";border-radius:34px;@media screen and (max-width:768px){border-radius:24px;padding-top:48px;padding-left:24px;padding-right:24px;padding-bottom:48px;}"], function (props) {
  return props.theme.layout == "dark" ? "var(--dark-gray-9)" : "var(--light-gray-4)";
});
var Container = styled.div.withConfig({
  displayName: "start-youngcomponent__Container",
  componentId: "sc-7t390v-1"
})(["margin-left:auto;margin-right:auto;max-width:1140px;width:100%;box-sizing:border-box;@media screen and (max-width:768px){padding-left:24px;padding-right:24px;}"]);
var StartYoung = function StartYoung(_ref) {
  var style = _ref.style,
    titleText = _ref.titleText,
    link = _ref.link,
    buttonText = _ref.buttonText,
    buttonIcon = _ref.buttonIcon,
    onButtonClick = _ref.onButtonClick,
    icon = _ref.icon;
  _ref.background;
  var LinkComponent = _ref.LinkComponent,
    textStyle = _ref.textStyle,
    isMobile = _ref.isMobile;
  _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Div, {
    theme: useContext(ThemeContext),
    style: _objectSpread({
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      boxSizing: "border-box",
      overflow: "hidden"
    }, style)
  }, icon ? /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: "product-icon",
    style: {
      marginBottom: isMobile ? "16px" : "34px",
      width: "70px",
      height: "70px"
    },
    width: "70",
    height: "70"
  }) : null, /*#__PURE__*/React__default.createElement(StartYoungHeader, {
    titleText: titleText,
    textStyle: textStyle,
    buttonText: buttonText,
    buttonIcon: buttonIcon,
    LinkComponent: LinkComponent,
    link: link,
    onButtonClick: onButtonClick,
    theme: useContext(ThemeContext)
  })));
};
var startYoung_component = withTheme(StartYoung);
export { startYoung_component as default };